export default __webpack_public_path__ + "static/media/group42.4e3f8e56.svg";